export { TalkPeople } from "./talkPeople";
